"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var FormControlLabel = function (_a) {
    var classes = _a.classes, checked = _a.checked, control = _a.control, disabled = _a.disabled, inputRef = _a.inputRef, label = _a.label, _b = _a.labelPlacement, labelPlacement = _b === void 0 ? 'end' : _b, onChange = _a.onChange, value = _a.value;
    return (react_1.default.createElement(FormControlLabel_1.default, { classes: classes, checked: checked, control: control, disabled: disabled, inputRef: inputRef, label: label, labelPlacement: labelPlacement, onChange: onChange, value: value }));
};
exports.default = FormControlLabel;
